export const TranscriptionStatus = {
	SUCCESS: 'Success',
	ERROR: 'Error',
	PENDING: 'Pending',
};
